<style lang="scss" scoped>
.icon {
  fill: currentColor;
  height: 1em;
  overflow: hidden;
  vertical-align: -0.15em;
  width: 1em;
}
</style>
<template>
    <svg class="icon" aria-hidden="true">
        <use :xlink:href="'#' + icon"></use>
    </svg>
</template>
<script>
import './lib/symbol';

export default {
  name: 'svg-i',
  props: {
    icon: {
      type: String,
    },
  },
};
</script>
